export default {
	/**
	 * Create a new blank day.
	 *
	 * @return object
	 */
	newBlankDay() {
		let day = this.getNextDay();

		return {
			id: null,
			day,
			baume: '',
			temp: '',
			comments: '',
			action: {
				data: {
					aeration: false,
					pump_over: false,
					dap: '',
					juice: '',
					reinoculate: '',
					water: '',
					agitator: '0'
				}
			},
			analysis: {
				data: {
					cell_count: '',
					fs02: '',
					gf: '',
					ntu: '',
					ph: '',
					ta: '',
					ts02: '',
					alcohol: '',
					malic_acid: ''
				}
			}
		};
	},
}



// WEBPACK FOOTER //
// ./src/components/ferment/daily-data/day-helpers.js